// extracted by mini-css-extract-plugin
export var video_overlay = "YouTubeVideoModal-module--video_overlay--iwIqu";
export var video_overlay_content = "YouTubeVideoModal-module--video_overlay_content--8t4Lw";